import React from 'react';
import { Cta, Heading, Reveal, Section } from './primitives';

const THOUGHTS = [
  "I'm not enough.",
  "I'm behind.",
  'What if I fail?',
  "I'll be happy when…",
  "Why can't I stop thinking about this?",
];

const FLOW = [
  { label: 'Automatic thoughts', color: '#e5867a' },
  { label: 'Awareness', color: '#f2cc66' },
  { label: 'Intentional practice', color: '#8b6bff' },
  { label: 'New inner dialogue', color: '#7fcfa6' },
];

export default function Problem({ variant }) {
  return (
    <Section className="bg-[#111111]/40">
      <Reveal className="text-center">
        <Heading
          lines={['You talk to yourself all day.', 'What are you repeating?']}
          className="text-3xl md:text-5xl"
        />
      </Reveal>

      <div className="mt-12 space-y-3">
        {THOUGHTS.map((t, i) => (
          <Reveal key={t} delay={i * 0.06}>
            <p className="glass-card border-l-2 border-l-[#e5867a]/70 px-5 py-4 font-jakarta text-xl italic text-white/85">
              “{t}”
            </p>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-12 text-center">
        <p className="mx-auto max-w-xl text-white/70">
          DepthMe turns inner work into a simple daily practice using personalized guidance,
          repetition, reflection, gratitude and journaling.
        </p>
      </Reveal>

      <Reveal className="mt-10">
        <ol className="grid grid-cols-2 gap-3 md:grid-cols-4">
          {FLOW.map((step, i) => (
            <li key={step.label} className="glass-card px-4 py-5 text-center">
              <span className="block text-[10px] tracking-[0.2em] text-white/40">0{i + 1}</span>
              <span className="mt-2 block text-sm font-medium uppercase tracking-wider" style={{ color: step.color }}>
                {step.label}
              </span>
            </li>
          ))}
        </ol>
      </Reveal>

      <Reveal className="mt-12 text-center">
        <Cta variant={variant}>Change the conversation</Cta>
      </Reveal>
    </Section>
  );
}
